import {
  isParticipantDisabled,
  type ParticipantStatus,
  renderParticipantStatus,
} from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props {
  status: ParticipantStatus;
}

export const ParticipantDisabledStatus = (props: Props) => {
  const { status } = props;

  const isDisabled = isParticipantDisabled(status);
  const renderedStatus = renderParticipantStatus(status);

  if (!isDisabled) {
    return null;
  }

  return (
    <ChakraV3.AlertBanner
      status='info'
      alignItems='center'
      fontSize='sm'
      fontWeight='semibold'
      title={`This participant's status is ${renderedStatus}. It is now read-only and cannot be edited. If you would like to make changes, you must change the status from ${renderedStatus}.`}
    />
  );
};
